import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { ModalContext } from "../contexts/ModalContext";
import { Context } from "../contexts/AppContext";
import NewGalleryCreateP from "../PropertyList/NewGalleryCreateP";
import { postData } from "../../lib/utils";
import { useNavigate } from "react-router-dom";
function NewGalleryModal() {

  const navigate = useNavigate();
  const [galleryName, setGalleryName] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
 

 
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [modalOpen, setModalOpen] = useState(appState.modalData);
 
 
  Modal.setAppElement("#root");

   useEffect(() => {
     setModalOpen(appState.modalData); // modalOpen को अपडेट करें
   }, [appState.modalData]);
    

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "300px",
      height: "auto",
      width: "100%",
      overflow: "hidden",
      border:"1px solid #00bcd4",
      borderRadius:"10px"
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
    },
  };

  const closeModal = () =>  { 
    setAppState((prevState) => {
      return { ...prevState, 
        modalData:{ ...prevState.modalData, type: null, isOpen: false}};
    }); 
    }

  const btnHandler = async (type) => {
   
    
  if (type === "save") {
    // 🚫 prevent multiple clicks
    if (isSaving) return;

    if (!galleryName || !galleryName.trim()) return;

    try {
      setIsSaving(true);

      const json = await postData("galleries/create", {
        name: galleryName,
        title: galleryName,
        plan:appState?.adminDetails?.plan,
        folderId: appState.currentFolderData._id,
        templateId: appState.currentTemplateId,
        fheading: appState.currentFontFamilyVideoTitle,
        fbody: appState.currentFontFamilyVideoSubTitle,
      });

      if (json) {
        setAppState((prevState) => ({
          ...prevState,
          currentGalleryName: json.name,
          currentDBGalleryId: json._id,
        }));

        closeModal();
        navigate(`/studio/galleries/${json._id}/photos`);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsSaving(false); // ✅ reset
    }
  } else {
    closeModal();
  }
};

  return (
    <Modal isOpen={modalOpen.isOpen} onRequestClose={closeModal} style={customStyles}>
      <NewGalleryCreateP updateGalleryData={setGalleryName} />
      <div className="w-full flex justify-around mt-10">
        <button
          onClick={() => btnHandler("cancel")}
          className="text-white bg-gray-500 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5"
        >
          Cancel
        </button>
       <button
  onClick={() => btnHandler("save")}
  disabled={isSaving}
  className={`text-white px-5 py-2.5 rounded-lg text-sm ${
    isSaving
      ? "bg-gray-400 cursor-not-allowed"
      : "bg-gray-500 hover:bg-gray-700"
  }`}
>
  {isSaving ? "Saving..." : "Save"}
</button>
      </div>
    </Modal>
  );
}

export default NewGalleryModal;
